<template>
  <div class="tagManage">
    <box title="标签管理">
      <div class="tagManage__context">
        <div class="tool">
          <div class="checkAction">
            <p :class="{ action: isAction }" @click="isAction = true">
              标签类型管理
            </p>
            <p :class="{ action: !isAction }" @click="isAction = false">
              标签管理
            </p>
          </div>
          <el-button
            v-if="isAction"
            type="primary"
            size="large"
            @click="addTagType"
            v-show="menusList.indexOf('LABEL_MANAGE_ADD')!='-1'"
            >新增标签类型</el-button
          >
          <el-button
            v-if="!isAction"
            type="primary"
            size="large"
            @click="addTag"
            v-show="menusList.indexOf('LABEL_MANAGE_ADD')!='-1'"
            >新增标签</el-button
          >
        </div>
        <tag-type ref="type" v-if="isAction"></tag-type>
        <tag-mag ref="tag" v-if="!isAction"></tag-mag>
      </div>
    </box>
  </div>
</template>

<script>
import box from "../../component/box";
import tagType from "./components/tagType";
import tagMag from "./components/tagMag";
import Vue from "vue";
export default {
  name: "tagManger",
  components: { box, tagType, tagMag },
  data() {
    return {
      isAction: true,
      menusList:[],
    };
  },
  methods: {
    addTagType() {
      this.$refs.type.addDialog();
    },
    addTag() {
      this.$refs.tag.addDialog();
    },
  },
  mounted() {
    this.menusList=Vue.prototype.menusList

  }
};
</script>

<style lang="less" scoped>
.tagManage {
  &__context {
    height: 100%;
    padding: 36px;
    overflow: auto;
    font-size: 14px;
    .tool {
      margin-bottom: 36px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .checkAction {
        display: flex;
        p {
          cursor: pointer;
          width: 84px;
          height: 44px;
          text-align: center;
          line-height: 44px;
          border-bottom: 2px solid #e4e7ed;
        }
        .action {
          color: #2a62ff;
          border-bottom: 2px solid #2a62ff;
        }
      }
    }
  }
}
</style>
